// Next Imports
import Image from "next/image";
import Link from "next/link";

// MUI Imports
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  Box,
  Card,
  CardContent,
  Grid2 as Grid,
  Typography,
} from "@mui/material";

function RecentlyPublishedCard({
  slug,
  topic,
  topicSlug,
  title,
  description,
  author,
  date,
  readTime,
  authorImage,
  articleImage,
}) {
  return (
    <Card
      component={"article"}
      spacing={3}
      sx={{ borderRadius: "10px", marginBottom: "15px" }}
    >
      <Link href={`/blog/article/${slug}`} passHref legacyBehavior>
        <CardContent
          sx={{
            paddingBottom: "0px",
            padding: { xs: "10px !important", sm: "20px" },
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          <Grid container spacing={{ xs: 1.5, sm: 3 }}>
            <Grid size={{ xs: 5 }}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: "130px", sm: "270px" },
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <Image
                  src={articleImage ?? "/software_development_fallback.webp"}
                  // src={
                  //   " https://storage.googleapis.com/valentin-marko-blog/closures_in_js_diagram_c679a743c1.webp"
                  // }
                  alt={title}
                  fill
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  quality={50}
                  priority
                  fetchPriority="high"
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 7 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box>
                  <Box
                    component={Link}
                    href={`/blog/topic/${topicSlug}`}
                    sx={{
                      backgroundColor: "#EDF2F7",
                      padding: { xs: "5px 10px", sm: "5px 15px" },
                      borderRadius: "5px",
                      width: "auto",
                      display: "inline-flex",
                      justifyContent: "center",
                      marginBottom: { xs: "10px", sm: "15px" },
                      marginTop: { xs: "10px", md: "20px" },
                      textDecoration: "none",
                      cursor: "pointer",
                      color: "#7F8DA1",
                      "&:hover": {
                        color: "#ffffff",
                        backgroundColor: "#718096",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: { xs: 600 },
                        fontSize: { xs: "10px", sm: "12px" },
                      }}
                    >
                      {topic}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      // fontSize: { xs: "34px", lg: "45px" },
                      color: "#2D3748",
                      marginRight: "8px",
                      fontSize: { xs: "17px", sm: "20px" },
                      fontWeight: 600,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      color: "rgb(113, 128, 150)",
                      marginTop: "16px",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "25px",
                      display: { xs: "none", sm: "-webkit-box" },
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {description}
                  </Typography>

                  <Box
                    sx={{
                      marginTop: "16px",
                      display: { xs: "none", sm: "flex" },
                      alignItems: "center",
                    }}
                  >
                    <Image
                      // src={`${process.env.NEXT_PUBLIC_BE_HOST_IMAGE}${authorImage.url}`}
                      src="/profilePhoto3.webp"
                      alt="Profile photo of Valentin-Marko"
                      width={70}
                      height={70}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      style={{
                        borderRadius: "50%",
                        marginRight: "10px",
                        objectFit: "cover",
                      }}
                      // style={{
                      //   width: "100%",
                      //   height: "auto",
                      //   borderRadius: "10px",
                      // }}

                      quality={50}
                      priority
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          // fontSize: { xs: "34px", lg: "45px" },
                          color: "rgb(113, 128, 150)",
                          marginTop: "16px",
                          fontSize: "14px",
                          fontWeight: 700,
                          fontFamily: "Inter",
                        }}
                      >
                        {author}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          marginTop: "16px",
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            // fontSize: { xs: "34px", lg: "45px" },
                            color: "rgb(160, 174, 192)",
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Inter",
                          }}
                        >
                          {date.split("T")[0]}
                        </Typography>
                        <AccessTimeIcon
                          sx={{
                            color: "rgb(160, 174, 192)",
                            fontSize: "16px",
                            fontWeight: 700,
                            cursor: "pointer",
                            marginLeft: "5px",
                            marginRight: "5px",
                          }}
                        />
                        <Typography
                          variant="p"
                          sx={{
                            // fontSize: { xs: "34px", lg: "45px" },
                            color: "rgb(160, 174, 192)",
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Inter",
                          }}
                        >
                          {readTime}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Typography
                  variant="p"
                  sx={{
                    display: { xs: "block", sm: "none" },
                    // fontSize: { xs: "34px", lg: "45px" },
                    color: "rgb(113, 128, 150)",
                    marginTop: "auto",
                    fontSize: "12px",
                    fontWeight: 700,
                    fontFamily: "Inter",
                    marginBottom: "5px",
                  }}
                >
                  {author}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Link>
    </Card>
  );
}

export default RecentlyPublishedCard;
